import { TeamForAdmin } from 'app/frontend/lib/admin/team/team-for-admin.type';
import { TeamForAdminService } from "./team-for-admin.service";
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AdminSearchService } from '../search/admin-search.service';
import { ActivatedRoute } from "@angular/router";
import { filter, from, mergeMap, tap } from "rxjs";

@Component({
    selector: 'admin-team-setup',
    templateUrl: './admin-team-setup.component.html',
    providers: [AdminSearchService],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AdminTeamSetupComponent implements OnInit {

  team: TeamForAdmin;
  features: string[];

  constructor(
    private adminSearchService: AdminSearchService,
    private teamForAdminService: TeamForAdminService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit() {
    const featureToggles = await this.adminSearchService.getFeaturesToggles();
    this.features = featureToggles.map(feature => feature.feature);

    this.route.params
        .pipe(
            filter(params => params.teamId),
            mergeMap(params => {
              return from(this.teamForAdminService.get(params.teamId));
            }),
            tap(team => {
              this.team = team;
            }),

        ).subscribe();
  }

   protected async reload() {
    this.team = await this.teamForAdminService.get(this.team.id);
  }
}